import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { melons } from "@/mocks/gossip";

export default function FeaturedMelons() {
  const [lead, ...rest] = melons;
  const sideMelons = rest.slice(0, 3);

  return (
    <section className="w-full bg-background-50" aria-labelledby="featured-title">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-8 md:py-16">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <h2 id="featured-title" className="sr-only">
              爆点瓜田
            </h2>
            <SectionHeading
              kicker="编辑精选"
              title="爆点瓜田"
              desc="从今天所有更新里挑出来最值得跟进的几条，每条都附完整时间线，方便你从头看起。"
            />
          </div>
          <Link
            to="/plaza"
            className="mb-8 hidden whitespace-nowrap rounded-full border border-primary-300 px-5 py-2.5 text-sm font-medium text-primary-800 transition-colors hover:bg-primary-100 md:inline-flex"
          >
            查看全部内容
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
          <article className="group relative col-span-1 overflow-hidden rounded-lg border border-background-200 lg:col-span-2">
            <Link to={`/article/${lead.id}`} className="block">
              <div className="relative h-64 w-full overflow-hidden bg-background-100 md:h-[26rem]">
                <img
                  src={lead.cover}
                  alt={lead.coverAlt}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/35 to-transparent"></div>
                <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
                  <div className="mb-3 flex flex-wrap items-center gap-2 text-xs">
                    <span className="rounded-full bg-accent-500 px-2.5 py-0.5 font-medium text-background-50">
                      今日首推
                    </span>
                    <span className="rounded-full bg-background-50/20 px-2.5 py-0.5 font-medium text-background-50 backdrop-blur">
                      {lead.categoryName}
                    </span>
                  </div>
                  <h3 className="font-heading text-xl font-bold leading-snug text-background-50 md:text-3xl">
                    {lead.title}
                  </h3>
                  <p className="mt-3 line-clamp-2 max-w-2xl text-sm text-background-200">
                    {lead.summary}
                  </p>
                  <div className="mt-4 flex flex-wrap items-center gap-4 text-xs text-background-300">
                    <span className="flex items-center gap-1">
                      <i className="ri-user-3-line" aria-hidden="true"></i>
                      {lead.author}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-calendar-line" aria-hidden="true"></i>
                      {lead.date}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line" aria-hidden="true"></i>
                      {lead.readTime}
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          </article>

          <div className="flex flex-col gap-4">
            {sideMelons.map((melon) => (
              <Link
                key={melon.id}
                to={`/article/${melon.id}`}
                className="group flex flex-1 items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300"
              >
                <div className="h-20 w-20 shrink-0 overflow-hidden rounded-md bg-background-100 md:h-24 md:w-24">
                  <img
                    src={melon.cover}
                    alt={melon.coverAlt}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="min-w-0">
                  <span className="text-xs font-medium text-primary-700">{melon.categoryName}</span>
                  <h3 className="mt-1 line-clamp-2 font-heading text-sm font-bold leading-snug text-foreground-950 md:text-base">
                    {melon.title}
                  </h3>
                  <p className="mt-1.5 text-xs text-foreground-400">{melon.date}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>

        <Link
          to="/plaza"
          className="mt-8 inline-flex w-full items-center justify-center gap-1 whitespace-nowrap rounded-full border border-primary-300 px-5 py-3 text-sm font-medium text-primary-800 transition-colors hover:bg-primary-100 md:hidden"
        >
          查看全部内容
          <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
        </Link>
      </div>
    </section>
  );
}